import React, {useState, useEffect} from "react";
import "./CustomSignIn.scss";
import {Link, useHistory, useLocation} from "react-router-dom";
import {Formik, Field, Form} from "formik";
import {initialValuesUserLogin, schemaUserLogin} from "./schemaValidation";
import useAmplifyAuth from "../../../helpers/useAmplifyAuth";
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import {useTranslation} from "react-i18next";
import {hideLoading} from "../../../reducers/app";
import {useDispatch} from "react-redux";
import {GenericErrorEnum} from "../../../helpers/enums";
import _ from "lodash";
import ChangePasswordChallenge from "../ChangePasswordChallenge/ChangePasswordChallenge";
import Recaptcha from "../../common/Recaptcha/Recaptcha";
import Modal from "../../common/Modal/Modal";
import {Trans} from "react-i18next";
import { client } from "../../../App";

const CustomSignIn = () => {
  const {t} = useTranslation();
  const location = useLocation();

  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState(initialValuesUserLogin);
  const [changePasswordChallenge, setChangePasswordChallenge] = useState({});
  const [infoModal, setInfoModal] = useState(false);
  const registerLabel = t("common.registerBtn");

  const {handleSignin} = useAmplifyAuth();

  const history = useHistory();

  useEffect(() => {
    const email = localStorage.getItem("remember_me") || null;
    if (email) {
      setInitialValues({
        username: email,
        password: "",
        rememberMe: true,
        recaptcha: "",
      });
    }
    return () => {
    };
  }, []);

  const handleLogin = async (values, {setErrors}, t) => {
    await client().clearStore();
    handleSignin(values.username, values.password)
      .then((data) => {
        console.log("User has been logged in. ", data);
        if (data.challengeName === "NEW_PASSWORD_REQUIRED") {
          dispatch(hideLoading());
          return setChangePasswordChallenge(data);
        }
        if (values.rememberMe) {
          localStorage.setItem("remember_me", values.username);
        } else {
          localStorage.removeItem("remember_me");
        }
        window.dataLayer.push({"event": "login"});
        if (location.state && location.state.from) {
          let {from} = location.state;
          if (from === '/logout' || from.pathname === '/logout') {
            from = null;
          }
          history.push(from || '/dashboard');
        } else {
          history.push('/dashboard');
        }
      })
      .catch((err) => {
        console.log("[ERROR CATCH]", err);
        if(err.message=== 'Password attempts exceeded') {
          setInfoModal(true)
        }
        switch (err.name) {
          case GenericErrorEnum.UserLambdaValidationException:
          case GenericErrorEnum.NotAuthorizedException:
          case GenericErrorEnum.PasswordResetRequiredException:
          case GenericErrorEnum.InvalidParameterException:
            setErrors({feedback: t(`error.login.${err.name}`)});
            break;
          default:
            setErrors({feedback: err.message});
            break;
        }
        dispatch(hideLoading());
      });
  };

  const [isRevealPwd, setIsRevealPwd] = useState(false);


  return (
    <div>
      {
        infoModal ?  <Modal
          descriptionClass={"active-section"}
          description={t("login.aws.user.blocked")}
          show={true}
          onClose={() => setInfoModal(false )}
        /> : null
      }
      {!_.isEmpty(changePasswordChallenge) ? (
        <ChangePasswordChallenge user={changePasswordChallenge}/>
      ) : (
        <div className={"CustomSignIn"} data-testid="CustomSignIn">
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={schemaUserLogin} //{getSchemaUserLogin()}
            onSubmit={(value, props) => handleLogin(value, props, t)}
          >
            {({errors, touched, submitCount}) => (
              <Form id={"form-login"} noValidate>
                <div className={"form-login-fields row"}>
                  <div className={"col-12"}>
                    <div className={
                      errors.username && touched.username && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }>
                      <label className="paragraph-small-fs9" htmlFor="username">
                        {t("login.username.value")}*
                      </label>
                      <Field
                        className={
                          errors.feedback ||
                          (errors.username &&
                            touched.username &&
                            submitCount > 0)
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                        key="username"
                        id="username"
                        name="username"
                        aria-describedby={
                          errors.username && touched.username && submitCount > 0
                            ? "username-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.email.placeholder")}
                      />
                      {errors.username &&
                       touched.username &&
                       submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"username-error"}
                        >
                          {errors.username}
                        </p>
                      ) : null}
                      {errors.feedback && (
                        <div className="invalid-feedback invalid-feedback-error">
                          {errors.feedback}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={"passwordField col-12"}>
                    <div className={
                      errors.password && touched.password && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }>
                      <label className="paragraph-small-fs9" htmlFor="password">
                        {t("login.password.value")}*
                      </label>
                      <Field
                        id="password"
                        name={"password"}
                        type={isRevealPwd ? "text" : "password"}
                        className={
                          errors.feedback ||
                          (errors.password &&
                            touched.password &&
                            submitCount > 0)
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.password && touched.password && submitCount > 0
                            ? "password-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.password.placeholder")}
                      />
                      <button
                        type="button"
                        aria-label={isRevealPwd ? t("hide.password.btn.label") : t("show.password.btn.label")}
                        onClick={() => setIsRevealPwd((prevState) => !prevState)}
                        className={isRevealPwd ? "gc-icon-service-sopralluogo-visualizza-1-col deleted-eye" : "gc-icon-service-sopralluogo-visualizza-1-col"}
                      >
                      </button>
                      {errors.password &&
                      touched.password &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"password-error"}
                        >
                          {errors.password}
                        </p>
                      ) : null}
                    </div>

                    <div
                      className={
                        "col-12 forgot-password-btn"
                      }
                    >
                      <Link className="paragraph-small-fs9 underlined-link" to={"/forgot-password"}>
                        {t("login.passwordRecovery")}
                      </Link>
                    </div>
                  </div>

                  <div className={"col-12 form-group checkbox-group"}>
                    <div className="form-check abc-checkbox">
                      <Field
                        id="rememberMe"
                        className={"form-check-input"}
                        type="checkbox"
                        name="rememberMe"
                      />

                      <label className="form-check-label" htmlFor="rememberMe">
                        {t("common.rememberMe")}
                      </label>
                    </div>
                  </div>

                  <div className={"col-12 recaptchaLogin"}>
                    <Recaptcha type="recaptcha" name="recaptcha"/>
                  </div>
                </div>

                <div className={"row footer-form-actions"}>
                    <div className="d-flex btn-content">
                      <button className={"btn btn-primary"} type="submit">
                        {t("login.loginBtn")}
                      </button>
                      <div className="paragraph-small-fs9">
                        <Trans
                          i18nKey={"login.new.register.label"}
                          values={{ctaLabel: registerLabel}}
                          parent=""
                          components={[<Link className="underlined-link" to={"/register"}>{t("common.registerBtn")}</Link>]}
                        />
                      </div>
                    </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </div>
  );
};


export default CustomSignIn;
